import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-filter-preset-name-form-dialog',
  templateUrl: './filter-preset-name-form-dialog.component.html',
  styleUrls: ['./filter-preset-name-form-dialog.component.scss'],
  standalone: false
})
export class FilterPresetNameFormDialogComponent {
  dialogRef = inject<MatDialogRef<FilterPresetNameFormDialogComponent>>(MatDialogRef);

  public name: string;

  constructor() { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onEnterKeydown(): void {
    this.dialogRef.close(this.name);
  }
}
